webpackJsonp([2],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+prg");
module.exports = __webpack_require__("lVK7");


/***/ }),

/***/ "0ag8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("rMlB");


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var goToPath = _ref.goToPath,
      orgName = _ref.orgName,
      repoName = _ref.repoName;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'form',
      {
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          var elements = e.target.elements;

          goToPath('/repo/' + elements.repoName.value);
        }
      },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('input', {
        name: 'repoName',
        value: orgName && repoName && orgName + '/' + repoName,
        placeholder: 'Enter user/repo name',
        className: 'appearance-none border rounded w-full py-2 px-3 text-grey-darker'
      })
    )
  );
});

/***/ }),

/***/ "9HTR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return goToPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__("ciQf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);


var history = __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()();

var getPath = function getPath() {
  return (history.location || window.location).pathname;
};
var goToPath = history.push.bind(history);

/* harmony default export */ __webpack_exports__["a"] = (history);

/***/ }),

/***/ "Cdj4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var ownerName = _ref.ownerName,
      repoName = _ref.repoName;

  if (ownerName) {
    if (repoName) {
      return '/repo/' + ownerName + '/' + repoName;
    } else {
      return '/repo/' + ownerName;
    }
  } else {
    return '/';
  }
});

/***/ }),

/***/ "D6w/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("rMlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_Link__ = __webpack_require__("NReD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Nav__ = __webpack_require__("SP1u");




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'h2',
      null,
      'Repos:'
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      __WEBPACK_IMPORTED_MODULE_2__components_Nav__["b" /* default */],
      { column: true },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        __WEBPACK_IMPORTED_MODULE_2__components_Nav__["a" /* NavItem */],
        { to: { ownerName: 'seek-oss', repoName: 'seek-style-guide' }, className: 'button' },
        'Seek Style Guide'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        __WEBPACK_IMPORTED_MODULE_2__components_Nav__["a" /* NavItem */],
        { to: { ownerName: 'stripe', repoName: 'react-stripe-elements' }, className: 'button' },
        'React Stripe Elements'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        __WEBPACK_IMPORTED_MODULE_2__components_Nav__["a" /* NavItem */],
        { to: { ownerName: 'RoyalIcing' }, className: 'button' },
        '@RoyalIcing'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        __WEBPACK_IMPORTED_MODULE_2__components_Nav__["a" /* NavItem */],
        { to: { ownerName: 'RoyalIcing', repoName: 'Collected' }, className: 'button' },
        '@RoyalIcing / Collected'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        __WEBPACK_IMPORTED_MODULE_2__components_Nav__["a" /* NavItem */],
        { to: { ownerName: 'RoyalIcing', repoName: 'lofi-bootstrap' }, className: 'button' },
        '@RoyalIcing / lofi-bootstrap'
      )
    )
  );
});

/***/ }),

/***/ "EDVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("rMlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_Link__ = __webpack_require__("NReD");



/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var ownerName = _ref.ownerName,
      repoName = _ref.repoName;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'h1',
    { className: 'text-lg' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      __WEBPACK_IMPORTED_MODULE_1__router_Link__["a" /* default */],
      { to: { ownerName: ownerName } },
      ownerName
    ),
    repoName && [' / ', Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      __WEBPACK_IMPORTED_MODULE_1__router_Link__["a" /* default */],
      { to: { ownerName: ownerName, repoName: repoName } },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'strong',
        null,
        repoName
      )
    )]
  );
});

/***/ }),

/***/ "GOuN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initial", function() { return initial; });
/* harmony export (immutable) */ __webpack_exports__["load"] = load;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_github__ = __webpack_require__("bteI");


var _marked = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default.a.mark(load);



var initial = function initial() {
  return {
    size: null,
    content: null
  };
};

function load(_ref, prev) {
  var url = _ref.url;
  return __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default.a.wrap(function load$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(!prev || url !== prev.url)) {
            _context.next = 5;
            break;
          }

          _context.next = 3;
          return function (previous) {
            return { size: null, content: null, previous: previous };
          };

        case 3:
          _context.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_1__api_github__["c" /* loadContents */])({ url: url }).then(function (_ref2) {
            var _ref2$data = _ref2.data,
                size = _ref2$data.size,
                content64 = _ref2$data.content;
            return {
              size: size,
              content: decodeURIComponent(escape(atob(content64)))
            };
          });

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/***/ }),

/***/ "HFpn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "grad1.dda3caef.svg";

/***/ }),

/***/ "NReD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onClickLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("rMlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__history__ = __webpack_require__("9HTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pathForState__ = __webpack_require__("Cdj4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_classes__ = __webpack_require__("nGOu");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var onClickLink = function onClickLink(_ref) {
  var href = _ref.target.href;
  return _this.history.push(href);
};

var Link = function Link(props) {
  var href = props.href,
      to = props.to,
      _props$button = props.button,
      button = _props$button === undefined ? false : _props$button,
      className = props.className,
      rest = _objectWithoutProperties(props, ['href', 'to', 'button', 'className']);

  if (to) {
    href = Object(__WEBPACK_IMPORTED_MODULE_2__pathForState__["a" /* default */])(to);
  }

  var classList = [className, 'no-underline'];
  if (button) {
    classList.push('inline-block bg-key hover:bg-purple-dark text-white font-bold py-2 px-3 rounded');
  } else {
    classList.push('hover:underline');
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('a', _extends({}, rest, {
    className: Object(__WEBPACK_IMPORTED_MODULE_3__components_classes__["a" /* default */])(classList),
    href: href,
    onClick: _this.onClickLink
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),

/***/ "RPlv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("rMlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_organism__ = __webpack_require__("F86v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GitHub_FileContent__ = __webpack_require__("blT5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_GitHub_FileContent__ = __webpack_require__("GOuN");
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var C = function C(_ref) {
  var loadError = _ref.loadError,
      rest = _objectWithoutProperties(_ref, ['loadError']);

  return !!loadError ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'p',
    null,
    'Error loading: ',
    loadError.message
  ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_2__components_GitHub_FileContent__["a" /* default */], rest);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_preact_organism__["a" /* default */])(C, __WEBPACK_IMPORTED_MODULE_3__state_GitHub_FileContent__));

/***/ }),

/***/ "SP1u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("rMlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_Link__ = __webpack_require__("NReD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes__ = __webpack_require__("nGOu");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var NavItem = function NavItem(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'li',
    { className: 'mb-1' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_1__router_Link__["a" /* default */], _extends({
      button: true
    }, props))
  );
};

/* harmony default export */ __webpack_exports__["b"] = (function (_ref) {
  var _ref$column = _ref.column,
      column = _ref$column === undefined ? false : _ref$column,
      children = _ref.children;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'nav',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'ul',
      { className: Object(__WEBPACK_IMPORTED_MODULE_2__classes__["a" /* default */])(['list-reset', 'justify-content-between', column && 'flex-column']) },
      children
    )
  );
});

/***/ }),

/***/ "U55j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "repo", function() { return repo; });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {};
});

var repo = function repo(props, orgName, repoName) {
  return {
    orgName: orgName, repoName: repoName
  };
};

/***/ }),

/***/ "Ue/Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XVpw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("rMlB");


var dropExtension = function dropExtension(name) {
  return name.split('.').slice(0, -1).join('.');
};

var humanize = function humanize(camelCase) {
  return camelCase.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var name = _ref.name,
      path = _ref.path,
      sha = _ref.sha,
      url = _ref.url;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'h2',
      null,
      humanize(dropExtension(name))
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'p',
      null,
      path
    )
  );
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stateForPath__ = __webpack_require__("mG0R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stateHandlers__ = __webpack_require__("U55j");



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__stateForPath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__stateHandlers__));

/***/ }),

/***/ "blT5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("rMlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_organism__ = __webpack_require__("F86v");


var JSCodeBlock = __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "AeJB"));

var PlainCodeBlock = function PlainCodeBlock(_ref) {
  var children = _ref.children;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'pre',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'code',
      null,
      children
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_preact_organism__["a" /* default */])(function (_ref2) {
  var size = _ref2.size,
      content = _ref2.content,
      CodeBlock = _ref2.CodeBlock;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'dl',
      null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'dt',
        null,
        'Size'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'dd',
        null,
        size
      )
    ),
    content && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      CodeBlock,
      null,
      content
    )
  );
}, {
  initial: function initial() {
    return {
      CodeBlock: PlainCodeBlock
    };
  },
  load: function load() {
    return JSCodeBlock.then(function (module) {
      return { CodeBlock: module.default };
    });
  }
}));

/***/ }),

/***/ "bteI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return listRepos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listJSAllComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadContents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var api = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: 'https://api.github.com'
});

var listRepos = function listRepos(owner) {
  return api.get('/users/' + owner + '/repos');
};

var searchCode = function searchCode(queryParts) {
  return api.get('/search/code', {
    params: {
      q: queryParts.join(' ')
    }
  });
};

// https://api.github.com/search/code?q=molecules+in:path+language:js+repo:RoyalIcing/lofi.design
var listJSComponents = function listJSComponents(_ref) {
  var repo = _ref.repo;
  return searchCode(['components', 'in:path', 'language:js', 'repo:' + repo]).then(function (res) {
    return res.data.items;
  });
};

var listJSMolecules = function listJSMolecules(_ref2) {
  var repo = _ref2.repo;
  return searchCode(['molecules', 'in:path', 'language:js', 'repo:' + repo]).then(function (res) {
    return res.data.items;
  });
};

var listJSReactDir = function listJSReactDir(_ref3) {
  var repo = _ref3.repo;
  return searchCode(['react', 'in:path', 'language:js', 'repo:' + repo]).then(function (res) {
    return res.data.items;
  });
};

var listJSAllComponents = function listJSAllComponents(_ref4) {
  var repo = _ref4.repo;
  return Promise.all([listJSComponents({ repo: repo }), listJSMolecules({ repo: repo }), listJSReactDir({ repo: repo })]).then(function (arrayOfItems) {
    var _ref5;

    return (_ref5 = []).concat.apply(_ref5, arrayOfItems);
  });
};

var loadContents = function loadContents(_ref6) {
  var url = _ref6.url;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url);
};

/***/ }),

/***/ "cilB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l1hP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("rMlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_organism__ = __webpack_require__("F86v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_GitHub_Repos__ = __webpack_require__("mZye");




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_preact_organism__["a" /* default */])(function (_ref) {
  var ownerName = _ref.ownerName,
      repos = _ref.repos,
      Link = _ref.Link;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    null,
    repos ? repos.map(function (item) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        Link,
        {
          href: '/repo/' + item.full_name
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'h2',
          null,
          item.name
        )
      );
    }) : 'Loading repos for ' + ownerName + '\u2026'
  );
}, __WEBPACK_IMPORTED_MODULE_2__state_GitHub_Repos__));

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__("cilB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("rMlB");




if (false) {
  // Enable Preact debug output and use of React Developer Tools
  //require('preact/debug')
}

var root = void 0;
function init() {
  var App = __webpack_require__("pnOm").default;
  root = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["e" /* render */])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(App, null), document.querySelector('#app'), root);
}

if (false) {
  module.hot.accept('./App', init);
}

init();

/***/ }),

/***/ "mG0R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (stateHandlers) {
  return function (path, props) {
    var pieces = path.split('/');

    if (pieces[0] === '') {
      pieces.shift();
    }

    if (pieces[pieces.length - 1] === '') {
      pieces.pop();
    }

    if (pieces.length === 0) {
      return stateHandlers.default(props);
    }

    var first = pieces[0],
        rest = pieces.slice(1);

    if (stateHandlers[first]) {
      return stateHandlers[first].apply(null, [props].concat(rest));
    }

    return { notFound: true };
  };
});

/***/ }),

/***/ "mZye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initial", function() { return initial; });
/* harmony export (immutable) */ __webpack_exports__["load"] = load;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_github__ = __webpack_require__("bteI");


var _marked = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default.a.mark(load);



var initial = function initial() {
  return {
    repos: null
  };
};

function load(_ref, prev) {
  var ownerName = _ref.ownerName;
  return __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default.a.wrap(function load$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(!prev || ownerName !== prev.ownerName)) {
            _context.next = 5;
            break;
          }

          _context.next = 3;
          return { repos: null };

        case 3:
          _context.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_1__api_github__["b" /* listRepos */])(ownerName).then(function (_ref2) {
            var repos = _ref2.data;
            return { repos: repos };
          });

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/***/ }),

/***/ "nGOu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (classes) {
  return classes.filter(Boolean).join(' ');
});

/***/ }),

/***/ "pnOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__("Ue/Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact__ = __webpack_require__("rMlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_github__ = __webpack_require__("bteI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__organisms_GitHub_SearchRepos__ = __webpack_require__("0ag8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__organisms_GitHub_RepoComponents__ = __webpack_require__("uPTJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__organisms_GitHub_ListRepos__ = __webpack_require__("l1hP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__organisms_Welcome__ = __webpack_require__("D6w/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__organisms_GitHub_Header__ = __webpack_require__("EDVf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Nav__ = __webpack_require__("SP1u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_history__ = __webpack_require__("9HTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_Link__ = __webpack_require__("NReD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__grad1_svg__ = __webpack_require__("HFpn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__grad1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__grad1_svg__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = _extends({
      path: Object(__WEBPACK_IMPORTED_MODULE_11__router_history__["b" /* getPath */])(),
      orgName: null,
      repoName: null
    }, Object(__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_11__router_history__["b" /* getPath */])()), {
      error: null,
      jsComponents: null,
      activePath: null
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  App.prototype.render = function render(props, _ref) {
    var _this2 = this;

    var error = _ref.error,
        path = _ref.path,
        notFound = _ref.notFound,
        orgName = _ref.orgName,
        repoName = _ref.repoName,
        jsComponents = _ref.jsComponents,
        activePath = _ref.activePath;

    return Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])(
      'div',
      { className: 'App' },
      Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])(
        __WEBPACK_IMPORTED_MODULE_9__components_Nav__["b" /* default */],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])(
          'div',
          { className: 'text-lg' },
          Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])(
            __WEBPACK_IMPORTED_MODULE_12__router_Link__["a" /* default */],
            { href: '/' },
            'Collected Hub'
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_4__organisms_GitHub_SearchRepos__["a" /* default */], {
          orgName: orgName,
          repoName: repoName,
          goToPath: __WEBPACK_IMPORTED_MODULE_11__router_history__["c" /* goToPath */]
        })
      ),
      error && Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])(
        'p',
        null,
        error.message
      ),
      orgName && Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_8__organisms_GitHub_Header__["a" /* default */], {
        ownerName: orgName,
        repoName: repoName
      }),
      notFound && Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])(
        'p',
        null,
        'Not found'
      ) || orgName && (repoName && Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_5__organisms_GitHub_RepoComponents__["a" /* default */], {
        orgName: orgName,
        repoName: repoName,
        jsComponents: jsComponents,
        activePath: activePath,
        onChangeActivePath: function onChangeActivePath(activePath) {
          return _this2.setState({ activePath: activePath });
        }
      }) || Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_6__organisms_GitHub_ListRepos__["a" /* default */], {
        ownerName: orgName,
        Link: __WEBPACK_IMPORTED_MODULE_12__router_Link__["a" /* default */]
      })) || Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_7__organisms_Welcome__["a" /* default */], null),
      Object(__WEBPACK_IMPORTED_MODULE_2_preact__["c" /* h */])('img', { src: __WEBPACK_IMPORTED_MODULE_13__grad1_svg___default.a })
    );
  };

  App.prototype.load = function load(current, prev) {
    var _this3 = this;

    var orgName = current.orgName,
        repoName = current.repoName;

    if (!!orgName && !!repoName && orgName !== prev.orgName || repoName !== prev.repoName) {
      Object(__WEBPACK_IMPORTED_MODULE_3__api_github__["a" /* listJSAllComponents */])({ repo: orgName + '/' + repoName }).then(function (jsComponents) {
        _this3.setState({ jsComponents: jsComponents });
      }).catch(function (error) {
        _this3.setState({ error: error });
      });
    }
  };

  App.prototype.componentDidMount = function componentDidMount() {
    var _this4 = this;

    this.stopHistory = __WEBPACK_IMPORTED_MODULE_11__router_history__["a" /* default */].listen(function (location) {
      return _this4.setState(Object(__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */])(location.pathname, _this4.props));
    });

    this.load(this.state, {});
  };

  App.prototype.componentDidUpdate = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(prevProps, prevState) {
      return __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.load(this.state, prevState);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function componentDidUpdate(_x, _x2) {
      return _ref2.apply(this, arguments);
    }

    return componentDidUpdate;
  }();

  App.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopHistory();
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_2_preact__["a" /* Component */]);



/***/ }),

/***/ "uPTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("rMlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GitHub_File__ = __webpack_require__("XVpw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FileContent__ = __webpack_require__("RPlv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_classes__ = __webpack_require__("nGOu");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var jsComponents = _ref.jsComponents,
      activePath = _ref.activePath,
      onChangeActivePath = _ref.onChangeActivePath;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    { className: 'relative' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      {
        className: Object(__WEBPACK_IMPORTED_MODULE_3__components_classes__["a" /* default */])(['hidden', 'md:flex', 'flex-col', 'md:max-w-xs', 'absolute', 'pin-y', 'pin-l', 'overflow-y-scroll'])
      },
      jsComponents ? jsComponents.map(function (item) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'button',
          {
            className: Object(__WEBPACK_IMPORTED_MODULE_3__components_classes__["a" /* default */])(['w-full text-left p-2', item.path === activePath && 'active']),
            onClick: function onClick() {
              return onChangeActivePath(item.path);
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_1__components_GitHub_File__["a" /* default */], _extends({
            key: item.path
          }, item))
        );
      }) : 'Loading…'
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      {
        className: Object(__WEBPACK_IMPORTED_MODULE_3__components_classes__["a" /* default */])(['md:ml-max-w-xs'])
      },
      !!activePath && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_2__FileContent__["a" /* default */], {
        url: jsComponents.find(function (a) {
          return a.path === activePath;
        }).url
      })
    )
  );
});

/***/ })

},[0]);


// WEBPACK FOOTER //
// app.ff34ab11.js